import React from 'react';

import militaryImg from '../../../assets/img/brand/milcom-logo.png';

class PartnerView extends React.Component {
  render() {
    return (
      <div className="invite-friend-container text-center">
        <center>
          <img
            height="131.14"
            width="437.66"
            className="mt-1 img-fluid"
            alt="education-center desktop"
            src={militaryImg}
            loading="lazy"
          />
        </center>
      </div>
    );
  }
}

export default PartnerView;
